import { Component, Inject, Input } from '@angular/core'
import { SeMembershipCard, SeMembershipCardMembership } from './membership-card-types'
import { SeMembershipCardService } from './membership-card.service'
import { SeMenuOptions, SeMenuItem } from '../menu/menu.component'
import uuidUtility from '../core/uuid-utility'

@Component({
  standalone: false,
  selector: 'se-membership-card',
  templateUrl: './membership-card.component.html',
})
export class SeMembershipCardComponent {

  @Input('se-data-card') card: SeMembershipCard
  @Input('se-data-multiple') multiple: boolean = false
  @Input('se-data-full-width') fullWidth: boolean = false
  public menuActionId: string
  public cardId: string
  public orgName: string
  public cardMenuItems: SeMenuItem[]
  public cardMenuOptions: SeMenuOptions
  private singleMembership: SeMembershipCardMembership
  private multipleMemberships: SeMembershipCardMembership[]

  constructor(private membershipCardService: SeMembershipCardService) {
    // noop
  }

  ngOnInit(): void {
    this.cardMenuItems = []
    this.cardMenuOptions = { sections: [{ menuItems: this.cardMenuItems }] }
    this.initializeMenuItem('Add to Apple Wallet', this.card.appleWalletLink)
    this.initializeMenuItem('Add to Google Pay', this.card.googlePayLink)
    this.menuActionId = uuidUtility.getUuid()
    this.cardId = uuidUtility.getUuid()
    this.updateOrgName()
    this.singleMembership = !this.multiple && this.card.memberships[0]
    this.multipleMemberships = !!this.multiple && this.card.memberships
  }

  ngOnChanges(): void {
    this.updateOrgName()
  }

  private updateOrgName(): void {
    this.orgName = this.card.organizations[this.card.organizations.length - 1].identity
  }

  private initializeMenuItem(text: string, link: string): void {
    if (!link) return
    this.cardMenuItems.push({
      text: text,
      action: () => window.location.href = link
    })
  }

}
